document.addEventListener('DOMContentLoaded', function() {
  const parents = document.querySelectorAll('.product_dis_in');
  parents.forEach((parent, parentIndex) => {
    console.log(`Parent ${parentIndex + 1}:`, parent);
    const children = Array.from(parent.children);
    const readMoreBtn = parent.querySelector('#pro_read_dis');
    const hasMoreThanTwoChildren = children.length > 2;
    const firstChildText = children[0]?.textContent.trim() || '';
    const isFirstChildLong = firstChildText.length > 50;
    if ((hasMoreThanTwoChildren || isFirstChildLong) && readMoreBtn) {
      readMoreBtn.style.display = 'inline-block';
    }
    if (isFirstChildLong && children.length <= 2) {
      parent.classList.add('moreHeight');
    }
    if (readMoreBtn) {
      readMoreBtn.addEventListener('click', function () {
        parent.classList.toggle('active');
        this.textContent = this.textContent === 'Read More +' ? 'Read Less -' : 'Read More +';
        this.closest('.about_vdimg_col')?.classList.toggle('active');
      });
      console.log(`Read More Button in Parent ${parentIndex + 1}:`, readMoreBtn);
    }
    children.forEach((child, childIndex) => {
      console.log(`Child ${childIndex + 1} in Parent ${parentIndex + 1}:`, child);
    });
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//     var searchTitle = document.querySelector(".search_menu_title");
//     var searchInput = document.querySelector(".search_input-wrp");

//         searchTitle.addEventListener("click", function () {
//             this.style.display = "none";
//             searchInput.style.display = "block";
//         });
// });


// document.addEventListener("DOMContentLoaded", function () {
//     var searchInput = document.querySelector(".search__input");
//     var searchTitle = document.querySelector(".search_menu_title");

//     searchInput.addEventListener("input", function () {
//         if (this.value.trim() !== "") {
//             document.body.classList.add("search-active");
//             searchTitle.style.display = "block";
//         } else {
//             document.body.classList.remove("search-active");
//             searchTitle.style.display = "none";
//         }
//     });
// });

document.addEventListener("DOMContentLoaded", function () {

    function HideSearchAll(){
      const inputWrap = document.querySelector('.search_input-wrp');
      const searchTitle = document.querySelector('.search_menu_title');
      if (inputWrap) { inputWrap.style.display = 'none'; }
      if (searchTitle) { searchTitle.style.display = 'block';}
      var searchInput = document.querySelector("#Search-In-Modal");
      searchInput.value = "";
      searchInput.dispatchEvent(new Event("input"));
      searchInput.dispatchEvent(new Event("change"));      
    }

    function hideSearchInputOnClose() {
    const closeBtn = document.querySelector('#predictive-search-results .search_popup_close');
          if (closeBtn) {
              closeBtn.addEventListener('click', function () {
                  HideSearchAll();
              });
              const searchHeader = document.querySelector('.predictive-search.predictive-search--header');
              if (searchHeader) {
                searchHeader.addEventListener('click', function(event) {
                  event.stopPropagation();
                });
              }
              document.body.addEventListener('click', function() {
                HideSearchAll();
              });

          }

    }
  
    var searchInput = document.querySelector("#Search-In-Modal");
    var searchTitle = document.querySelector(".search_menu_title");
    var searchWrapper = document.querySelector(".search_input-wrp");

    searchTitle.addEventListener("click", function () {
        this.style.display = "none";
        searchWrapper.style.display = "block";
    });

    searchInput.addEventListener("input", function () {
        if (this.value.trim() !== "") {
            document.body.classList.add("search-active");
          } else {
            searchTitle.style.display = "block";
            searchWrapper.style.display = "none"; 
            document.body.classList.remove("search-active");
          }
          setInterval(function () {
              hideSearchInputOnClose();
          }, 300);
    });

});






document.addEventListener('click', function(event) {
  const item = event.target.closest('.predictive-search__list-item');
  if (item) {
    const link = item.querySelector('a');
    if (link && link.href) {
      window.location.href = link.href;
    }
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//     var searchInput = document.querySelector(".search__input");
//     var searchTitle = document.querySelector(".search_menu_title");

//     searchInput.addEventListener("input", function () {
//         if (this.value.trim() !== "") {
//             document.body.classList.add("search-active");
//             searchInput.style.display = "block";
//             searchTitle.style.display = "none";
//         } else {
//             document.body.classList.remove("search-active");
//             searchInput.style.display = "none";
//             searchTitle.style.display = "block";
//         }
//     });

//     if (searchInput.value.trim() === "") {
//         searchInput.style.display = "none";
//         searchTitle.style.display = "block";
//     }
//     searchTitle.addEventListener("click", function () {
//         searchInput.style.display = "block";
//         searchTitle.style.display = "none";
//     });
// });



// document.querySelectorAll(".product__additional").forEach(function(element) {
//     element.addEventListener("click", function() {
//         // Add 'active' class to clicked element
//         element.classList.add('active');
        
//         // Find the description inside the clicked element and show it
//         var description = element.querySelector('.product__additional-description');
//         if (description) {
//             description.style.display = "block";
//         }
        
//         // Optionally, remove 'active' class after some time and hide the description
//         setTimeout(function() {
//             element.classList.remove('active');
//             if (description) {
//                 description.style.display = "";
//             }
//         }, 3000); // 3000ms = 3 seconds
//     });
// });


// $(document).ready(function () {  
//     var popupCookie = "popup_closed";
//     var popup = $(".kl-private-reset-css-Xuajs1");
//     function getCookie(name) {
//         var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
//         return match ? match[2] : null;
//     }
//     function setCookie(name, value, days) {
//         var expires = "";
//         if (days) {
//             var date = new Date();
//             date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//             expires = "; expires=" + date.toUTCString();
//         }
//         document.cookie = name + "=" + value + "; path=/" + expires;
//     }
//     setInterval(function(){
//       if (getCookie(popupCookie)) {
//           popup.remove();
//       }
//     }, 1000);  
  
//     setTimeout(function(){
//       $(".klaviyo-close-form").on("click", function () {
//           popup.hide();
//           setCookie(popupCookie, "true", 30);
//       });
//     }, 3000);
// });


// $(document).ready(function () {
//     var popupCookie = "popup_closed";

//     function getCookie(name) {
//         var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
//         return match ? match[2] : null;
//     }

//     function setCookie(name, value, days) {
//         var expires = "";
//         if (days) {
//             var date = new Date();
//             date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//             expires = "; expires=" + date.toUTCString();
//         }
//         document.cookie = name + "=" + value + "; path=/" + expires;
//     }

//     // Continuously check and remove the popup if cookie is set
//     setInterval(function () {
//         if (getCookie(popupCookie)) {
//             $(".klaviyo-form").closest('[role="dialog"]').remove();
//         }
//     }, 10);

//     // Delegate click handler to document so it works even if .klaviyo-close-form loads later
//     $(document).on("click", ".klaviyo-close-form", function () {
//         $(this).closest('[role="dialog"]').hide();
//         setCookie(popupCookie, "true", 30);
//     });
// });

$(document).ready(function(){
    $(".product-media-modal__toggle").on("click", function () {
      $("body").css("overflow", "");
    });
    	$('.card-wrapper .technical-button_wrp .common_btn').click(function(event){
	event.preventDefault();
let formData = {
		'items': [{
		'id': $(this).data('id'),
		'quantity': 1
		}]
	};
	fetch(window.Shopify.routes.root + 'cart/add.js', {
		method: 'POST',
		headers: {
		'Content-Type': 'application/json'
	},
		body: JSON.stringify(formData)
	})
	.then(response => {
		return response.json();
	})
		.then(response => {
		window.location.href = "/checkout";
	})
	.catch((error) => {
		console.error('Error:', error);
	});
});
});

  // document.addEventListener("DOMContentLoaded", function () {
  //   function toggleFormVisibility() {
  //     // Get the form element by class
  //     var formElement = document.querySelector(".klaviyo-form-version-cid_2");
  //     if (formElement) {
  //       if (window.location.href === "https://www.metamorphosislighttherapy.com/") {
  //         formElement.style.display = "block";
  //       } else {
  //         formElement.style.display = "none";
  //       }
  //     } else {
  //       // If not found yet, try again after 300ms
  //       setTimeout(toggleFormVisibility, 10);
  //     }
  //   }

  //   toggleFormVisibility();
  // });


  // $(document).ready(function() {
